import {
  ROUTES,
  ROLES,
  ORG_TYPES,
  DATE_TIME_PICKER,
  BREADCRUMBS,
  USER_MENU_LIST,
  DISPLAYS_MENU_LIST,
  DASHBOARD_MENU_LIST,
} from "./Constants";
import dayjs from "dayjs";
import { domains } from "./EnvVariables";
import {
  ProfileOutlined,
  UserAddOutlined,
  BarChartOutlined,
  LogoutOutlined,
  LineChartOutlined,
  AreaChartOutlined,
  BoxPlotOutlined,
  PicCenterOutlined,
  StarOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";

import { grafanaBaseUrl } from "./endpoints";
import { DASHBOARD_ICONS } from "./svgIconComponents";

export const setInfo = (data) => {
  localStorage.setItem("org", data?.slug);
}

export const setUserDetails = (data) => {
  localStorage.setItem("userToken", data?.authToken);
  localStorage.setItem("authToken", data?.authToken);
  const [mainOrganisation, ...otherOrganisations] = data?.organisations.sort(
    (a, b) => a.id - b.id
  );
  const userDetails = {
    email: data?.emailAddress,
    firstName: data?.firstName,
    lastName: data?.lastName,
    phoneNumber: data?.phoneNumber,
    organisations: data?.organisations,
    otherOrganisations: otherOrganisations,
    roles: data?.roles,
    currentRole: data?.roles?.[0],
    currentOrgRole: data?.roles?.[0],
    mainOrganisation: mainOrganisation,
    currentOrganisation: otherOrganisations?.[0] || mainOrganisation,
  };
  localStorage.setItem("userDetails", JSON.stringify(userDetails));
};

export const setOrgDetails = (data, orgId) => {
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  userDetails["currentOrgRole"] = data?.roles?.[0];
  userDetails["currentOrganisation"] =
    data?.organisations?.filter((org) => org.id === orgId)?.[0] || {};
  localStorage.setItem("authToken", data?.authToken);
  localStorage.setItem("userDetails", JSON.stringify(userDetails));
};

export const numberRegEx = /^[0-9]+$/;
export const decimalNagativeRegEx = /^[0-9.-]+$/;

export const numericInputValidator = (value, type) => {
  const patternType =
    type === "decimalNegative" ? decimalNagativeRegEx : numberRegEx;
  if (value && !patternType.test(value)) {
    return Promise.reject();
  }

  return Promise.resolve();
};

export const calculateDuration = (record) => {
  const timeDifference = record.stopTime - record.startTime;
  const seconds = timeDifference / 1000;
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (seconds >= 60) {
    const remainingSeconds = Math.floor(seconds % 60);
    if (minutes >= 60) {
      const remainingMinutes = Math.floor(minutes % 60);
      return `${hours}h ${remainingMinutes}m ${remainingSeconds}s`;
    } else {
      return `${minutes}m ${remainingSeconds}s`;
    }
  } else {
    return `${parseFloat(seconds).toFixed(0)}s`;
  }
};

export const formatDateAndTime = (timestamp) => {
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  return timestamp
    ? new Date(timestamp).toLocaleDateString("en-US", options).replace(",", "")
    : "";
};

export const formatShortDateAndTime = (timestamp) => {
  const inDate = new Date(timestamp)
  const formattedDate = ('0' + inDate.getDate()).slice(-2) + '-' + 
  // ('0' + (inDate.getMonth() + 1)).slice(-2) + '-' + 
  inDate.toLocaleString('en-US', { month: 'short' }) + '-' +
  inDate.getFullYear().toString().slice(2)  + ' ' +
  ('0' + inDate.getHours()).slice(-2) + ':' + 
  ('0' + inDate.getMinutes()).slice(-2);
return(formattedDate); 
};

export const formatShortDateOnly = (timestamp) => {
  const inDate = new Date(timestamp)
  const formattedDate = ('0' + inDate.getDate()).slice(-2) + '-' + 
  inDate.toLocaleString('en-US', { month: 'short' }) + '-' +
  inDate.getFullYear().toString().slice(2)
return(formattedDate); 
}

export const formatOnlyTime = (timestamp) => {
  const inDate = new Date(timestamp)
  const formattedDate = 
  ('0' + inDate.getHours()).slice(-2) + ':' + 
  ('0' + inDate.getMinutes()).slice(-2) + ':' +
  ('0' + inDate.getSeconds()).slice(-2);
return(formattedDate); 
};

export const formatHourAndMins = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);

  return hours ? hours + "h " + minutes + "m" : minutes + "m";
};

export const formatHourAndMinsAndSecs = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / (60 * 60)) || 0;
  const minutes = Math.floor((totalSeconds % (60 * 60)) / (60)) || 0;
  const seconds = Math.floor(totalSeconds % 60) || 0;
  const timeParts = [];
  timeParts.push(`${hours.toString().padStart(2, '0')}`);
  timeParts.push(`${minutes.toString().padStart(2, '0')}`);
  timeParts.push(`${seconds.toString().padStart(2, '0')}`);
  return(timeParts.join(':'))
};

const getItem = (label, key, icon, children, type) => {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
};

const defaultDashboards = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  let items = [];
  if (userDetails?.currentOrganisation?.type === ORG_TYPES.DEALER) {
    items.push(
      getItem(
        ROUTES.DEALER_SLIDESHOW.title,
        ROUTES.DEALER_SLIDESHOW.key,
        <PicCenterOutlined style={{ fontSize: 16 }} />
      )
    );
    items.push(
      getItem(
        ROUTES.DEALER_SERVICE.title,
        ROUTES.DEALER_SERVICE.key,
        <StarOutlined style={{ fontSize: 16 }} />
      )
    );
    items.push(
      getItem(
        ROUTES.DEALER_PERFORMANCE.title,
        ROUTES.DEALER_PERFORMANCE.key,
        <BarChartOutlined style={{ fontSize: 16 }} />
      )
    );
  } else {
    if (userDetails?.currentOrganisation?.type !== ORG_TYPES.B2B_CUSTOMER) {
      items.push(
        getItem(
          ROUTES.VEHICLE_ANALYTICS.title,
          ROUTES.VEHICLE_ANALYTICS.key,
          <DASHBOARD_ICONS.VEHICLE_ANALYTICS />
        )
      );
      items.push(
        getItem(
          ROUTES.VEHICLE_HEALTH.title,
          ROUTES.VEHICLE_HEALTH.key,
          <DASHBOARD_ICONS.VEHICLE_HEALTH />
        )
      );
      items.push(
        getItem(
          ROUTES.BATTERY_PERFORMANCE.title,
          ROUTES.BATTERY_PERFORMANCE.key,
          <DASHBOARD_ICONS.BATTERY_PERFORMANCE/>
        )
      );
      items.push(
        getItem(
          ROUTES.FLEET_MONITOR.title,
          ROUTES.FLEET_MONITOR.key,
          <DASHBOARD_ICONS.FLEET_MONITOR/>
        )
      );
      items.push(
        getItem(
          ROUTES.FLEET_ANALYTICS.title,
          ROUTES.FLEET_ANALYTICS.key,
          <DASHBOARD_ICONS.FLEET_ANALYTICS/>
        )
      );
      items.push({ type: "divider" });
      items.push(
        getItem(
          ROUTES.EOL_TESTS.title,
          ROUTES.EOL_TESTS.key,
          <DASHBOARD_ICONS.EOL_TESTS/>
        )
      );
      items.push(
        getItem(
          ROUTES.EOL_ANALYTICS.title,
          ROUTES.EOL_ANALYTICS.key,
          <DASHBOARD_ICONS.EOL_ANALYTICS/>
        )
      );
      items.push({ type: "divider" });
      items.push(
        getItem(
          ROUTES.TEST_RIDES.title,
          ROUTES.TEST_RIDES.key,
          <DASHBOARD_ICONS.TEST_RIDE/>
        )
      );
      items.push(
        getItem(
          ROUTES.TEST_RIDES_COMPARISON.title,
          ROUTES.TEST_RIDES_COMPARISON.key,
          <DASHBOARD_ICONS.TEST_RIDES_COMPARISON/>
        )
      );
      items.push({ type: "divider" });
      items.push(
        getItem(
          ROUTES.SPEAK_WITH_DATA.title,
          ROUTES.SPEAK_WITH_DATA.key,
          <DASHBOARD_ICONS.SPEAK_WITH_DATA/> 
        )
      );
      items.push(
        getItem(
          ROUTES.COMPETITOR.title,
          ROUTES.COMPETITOR.key,
          <DASHBOARD_ICONS.COMPETITOR_PULSE/>
        )
      );
    }
  }

  return items;
};

export const dashboardsList = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const dashboards = {
    [ROLES.ADMIN]: defaultDashboards(),
    [ROLES.EXECUTIVE]: defaultDashboards(),
    [ROLES.TEST_ENGINEER]: [
      getItem(
        ROUTES.VEHICLE_ANALYTICS.title,
        ROUTES.VEHICLE_ANALYTICS.key,
        <AreaChartOutlined style={{ fontSize: 16 }} />
      ),
      getItem(
        ROUTES.BATTERY_PERFORMANCE.title,
        ROUTES.BATTERY_PERFORMANCE.key,
        <BarChartOutlined style={{ fontSize: 16 }} />
      ),
      { type: "divider" },
      getItem(
        ROUTES.EOL_TESTS.title,
        ROUTES.EOL_TESTS.key,
        <LineChartOutlined style={{ fontSize: 16 }} />
      ),
      getItem(
        ROUTES.EOL_ANALYTICS.title,
        ROUTES.EOL_ANALYTICS.key,
        <BarChartOutlined style={{ fontSize: 16 }} />
      ),
    ],
    [ROLES.TEST_RIDE_ENGINEER]: [
      getItem(
        ROUTES.VEHICLE_ANALYTICS.title,
        ROUTES.VEHICLE_ANALYTICS.key,
        <AreaChartOutlined style={{ fontSize: 16 }} />
      ),
      getItem(
        ROUTES.BATTERY_PERFORMANCE.title,
        ROUTES.BATTERY_PERFORMANCE.key,
        <BarChartOutlined style={{ fontSize: 16 }} />
      ),
      { type: "divider" },
      getItem(
        ROUTES.TEST_RIDES.title,
        ROUTES.TEST_RIDES.key,
        <LineChartOutlined style={{ fontSize: 16 }} />
      ),
      getItem(
        ROUTES.TEST_RIDES_COMPARISON.title,
        ROUTES.TEST_RIDES_COMPARISON.key,
        <BoxPlotOutlined style={{ fontSize: 16 }} />
      ),
    ],
    [ROLES.FLEET_MANAGER]: [
      getItem(
        ROUTES.VEHICLE_ANALYTICS.title,
        ROUTES.VEHICLE_ANALYTICS.key,
        <AreaChartOutlined style={{ fontSize: 16 }} />
      ),
      getItem(
        ROUTES.BATTERY_PERFORMANCE.title,
        ROUTES.BATTERY_PERFORMANCE.key,
        <BarChartOutlined style={{ fontSize: 16 }} />
      ),
      getItem(
        ROUTES.FLEET_MONITOR.title,
        ROUTES.FLEET_MONITOR.key,
        <AreaChartOutlined style={{ fontSize: 16 }} />
      ),
      getItem(
        ROUTES.FLEET_ANALYTICS.title,
        ROUTES.FLEET_ANALYTICS.key,
        <BarChartOutlined style={{ fontSize: 16 }} />
      )
    ],
  };
  return dashboards[userDetails?.currentOrgRole] || [];
};

export const displaysList = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  let items = [];
  if (
    ![ORG_TYPES.DEALER, ORG_TYPES.B2B_CUSTOMER].includes(
      userDetails?.currentOrganisation?.type
    ) &&
    ROLES.ERPUSER !== userDetails?.currentRole &&
    ROLES.FLEET_MANAGER !== userDetails?.currentRole
  ) {
    items.push(
      getItem(
        ROUTES.PRODUCT_HEALTH.title,
        ROUTES.PRODUCT_HEALTH.key,
        <LineChartOutlined style={{ fontSize: 16 }} />
      )
    );
    items.push(
      getItem(
        ROUTES.OPERATIONAL_PARAMETERS.title,
        ROUTES.OPERATIONAL_PARAMETERS.key,
        <BarChartOutlined style={{ fontSize: 16 }} />
      )
    );
  }

  return items;
};

export const rolesToExclude = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));

  const type = userDetails?.currentOrganisation?.type;
  if (type && type === ORG_TYPES.MANUFACTURER) {
    return [ROLES.RIDER, ROLES.ADMIN];
  } else if (type && type === ORG_TYPES.B2B_CUSTOMER) {
    return [ROLES.ADMIN, ROLES.TEST_ENGINEER, ROLES.TEST_RIDE_ENGINEER];
  } else {
    return [];
  }
};

export const redirectToRelatedPage = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  if (userDetails?.currentOrganisation?.type === ORG_TYPES.DEALER) {
    return ROUTES.DEALER_EXECUTIVE.link;
  } else if (userDetails?.currentRole === ROLES.FLEET_MANAGER) {
    return ROUTES.FLEET_MONITOR.link;
  } else {
    return ROUTES.HOME.link;
  }
};

export const userPages = (userDetails) => {
  const items = [
    getItem(
      ROUTES.PROFILE.title,
      ROUTES.PROFILE.key,
      <ProfileOutlined style={{ fontSize: 16 }} />
    ),
  ];
  if (userDetails?.currentRole === ROLES.ADMIN) {
    items.push(
      getItem(
        ROUTES.REGISTER.title,
        ROUTES.REGISTER.key,
        <UserAddOutlined style={{ fontSize: 16 }} />
      )
    );
  }
  if (
    userDetails?.mainOrganisation?.type === ORG_TYPES.ADMINISTRATOR &&
    userDetails?.otherOrganisations?.length > 0
  ) {
    items.push(
      getItem(
        ROUTES.CHANGE_ORG.title,
        ROUTES.CHANGE_ORG.key,
        <UserSwitchOutlined style={{ fontSize: 16 }} />
      )
    );
  }
  items.push(
    getItem(
      ROUTES.GRAFANA_LOGIN.title,
      ROUTES.GRAFANA_LOGIN.key,
      <BarChartOutlined style={{ fontSize: 16 }} />
    )
  );
  items.push({ type: "divider" });
  items.push(
    getItem(
      ROUTES.LOGOUT.title,
      ROUTES.LOGOUT.key,
      <LogoutOutlined style={{ fontSize: 16 }} />
    )
  );
  return items;
};

export const footerText = `EV Analytics © ${new Date().getFullYear()} Created by NicheSolv`;

export const getGrafanaInterval = (startTime, endTime) => {
  const timeDifference = Math.abs(endTime - startTime);
  const timeDifferenceMinutes = Math.floor(timeDifference / (1000 * 60));
  if (timeDifferenceMinutes > 60 * 24 * 7 * 3) {
    // return "2h";
    return "10m";
  } else if (
    timeDifferenceMinutes > 60 * 24 * 6 &&
    timeDifferenceMinutes <= 60 * 24 * 7 * 3
  ) {
    // return "1h";
    return "5m";
  } else if (
    timeDifferenceMinutes > 60 * 24 * 2 &&
    timeDifferenceMinutes <= 60 * 24 * 6
  ) {
    // return "15m";
    return "2m";
  } else if (
    timeDifferenceMinutes > 60 * 24 &&
    timeDifferenceMinutes <= 60 * 24 * 2
  ) {
    // return "5m";
    return "1m";
  } else if (timeDifferenceMinutes > 60 && timeDifferenceMinutes <= 60 * 24) {
    // return "1m";
    return "15s";
  } else if (timeDifferenceMinutes <= 60) {
    return "1s";
  }

  return "";
};

export const getGrafanaBatteryDataInterval = (startTime, endTime) => {
  const timeDifference = Math.abs(endTime - startTime);
  const timeDifferenceMinutes = Math.floor(timeDifference / (1000 * 60));
  if (timeDifferenceMinutes > 60 * 24 * 7 * 3) {
    //if time diff is above 3 weeks
    return "2h";
  } else if (
    timeDifferenceMinutes > 60 * 24 * 6 &&
    timeDifferenceMinutes <= 60 * 24 * 7 * 3
  ) {
    //if time diff is between 1 to 3 weeks
    return "1h";
  } else if (
    timeDifferenceMinutes > 60 * 24 * 2 &&
    timeDifferenceMinutes <= 60 * 24 * 6
  ) {
    //if time diff is between 2days to 6days
    return "1h";
  } else if (
    timeDifferenceMinutes > 60 * 24 &&
    timeDifferenceMinutes <= 60 * 24 * 2
  ) {
    //if time diff is 1day
    return "10m";
  } else if (timeDifferenceMinutes > 60 && timeDifferenceMinutes <= 60 * 24) {
    return "1m";
  } else if (timeDifferenceMinutes <= 60) {
    return "10s";
  }

  return "";
};

export const getGrafanaBatteryStackInterval = (startTime, endTime) => {
  const timeDifference = Math.abs(endTime - startTime);
  const timeDifferenceMinutes = Math.floor(timeDifference / (1000 * 60));
  if (timeDifferenceMinutes > 60 * 24 * 7 * 3) {
    //if time diff is above 3 weeks
    return "2h";
  } else if (
    timeDifferenceMinutes > 60 * 24 * 6 &&
    timeDifferenceMinutes <= 60 * 24 * 7 * 3
  ) {
    //if time diff is between 1 to 3 weeks
    return "1h";
  } else if (
    timeDifferenceMinutes > 60 * 24 * 2 &&
    timeDifferenceMinutes <= 60 * 24 * 6
  ) {
    //if time diff is between 2days to 6days
    return "1h";
  } else if (
    timeDifferenceMinutes > 60 * 24 &&
    timeDifferenceMinutes <= 60 * 24 * 2
  ) {
    //if time diff is 1day
    return "10m";
  } else if (timeDifferenceMinutes > 60 && timeDifferenceMinutes <= 60 * 24) {
    return "1m";
  } else if (timeDifferenceMinutes <= 60) {
    return "10s";
  }

  return "";
};

export const getGrafanaBatteryCellInterval = (startTime, endTime) => {
  const timeDifference = Math.abs(endTime - startTime);
  const timeDifferenceMinutes = Math.floor(timeDifference / (1000 * 60));
  if (timeDifferenceMinutes > 60 * 24 * 7 * 3) {
    //if time diff is above 3 weeks
    return "2h";
  } else if (
    timeDifferenceMinutes > 60 * 24 * 6 &&
    timeDifferenceMinutes <= 60 * 24 * 7 * 3
  ) {
    //if time diff is between 1 to 3 weeks
    return "1h";
  } else if (
    timeDifferenceMinutes > 60 * 24 * 2 &&
    timeDifferenceMinutes <= 60 * 24 * 6
  ) {
    //if time diff is between 2days to 6days
    return "1h";
  } else if (
    timeDifferenceMinutes > 60 * 24 &&
    timeDifferenceMinutes <= 60 * 24 * 2
  ) {
    //if time diff is 1day
    return "10m";
  } else if (timeDifferenceMinutes > 60 && timeDifferenceMinutes <= 60 * 24) {
    return "1m";
  } else if (timeDifferenceMinutes <= 60) {
    return "10s";
  }

  return "";
};

export const grafanaDynamicSampling = (startTime, endTime, filterName, samplesPerMin=60, numOfVehicles=1) => {
  const timeDifference = Math.abs(endTime - startTime);
  const timeDifferenceMins = Math.floor(timeDifference / (1000 * 60));

  let interval = '10s';
  let maxPointsPerPanel = 300;
  let fieldsPerSecond = 1;
  
  if (filterName === 'cell') {
    fieldsPerSecond = 30;
  } else if (filterName === 'stack') {
    fieldsPerSecond = 8;
  } else if (filterName === 'battery') {
    fieldsPerSecond = 1;
  } else if (filterName === 'motor'){
    fieldsPerSecond = 1;
  } else {
    fieldsPerSecond = 1;
  }

  numOfVehicles = numOfVehicles === 0 ? 1 : numOfVehicles;
  const totalSamples = timeDifferenceMins * samplesPerMin * numOfVehicles * fieldsPerSecond;
  if (totalSamples >= maxPointsPerPanel ){
    const factor = Math.floor(totalSamples/maxPointsPerPanel);
    interval = `${factor}s`;
  } 
  // console.log('Sample Cal-->',
  //   {
  //     vehicle: numOfVehicles,
  //     perMin: samplesPerMin,
  //     timeDiff: timeDifferenceMins,
  //     interval: interval,
  //   }
  // );
  return interval;
}

export const timeRangePresets = [
  {
    label: DATE_TIME_PICKER.FILTER_LABLE.FIVE_MINS,
    value: [dayjs().subtract(5, "m"), dayjs()],
  },
  {
    label: DATE_TIME_PICKER.FILTER_LABLE.FIFTEEN_MINS,
    value: [dayjs().subtract(15, "m"), dayjs()],
  },
  {
    label: DATE_TIME_PICKER.FILTER_LABLE.THIRTY_MINS,
    value: [dayjs().subtract(30, "m"), dayjs()],
  },
  {
    label: DATE_TIME_PICKER.FILTER_LABLE.TODAY,
    value: [
      dayjs().set("hour", 0).set("minute", 0).set("second", 0),
      dayjs().endOf("day"),
    ],
  },
  {
    label: DATE_TIME_PICKER.FILTER_LABLE.YESTERDAY,
    value: [
      dayjs().subtract(1, "d").set("hour", 0).set("minute", 0).set("second", 0),
      dayjs().subtract(1, "d").endOf("day"),
    ],
  },
  {
    label: DATE_TIME_PICKER.FILTER_LABLE.THIS_WEEK,
    value: [
      dayjs()
        .subtract(dayjs().get("day"), "d")
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0),
      dayjs().endOf("day"),
    ],
  },
  {
    label: DATE_TIME_PICKER.FILTER_LABLE.LAST_WEEK,
    value: [
      dayjs()
        .subtract(dayjs().get("day") + 7, "d")
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0),
      dayjs()
        .subtract(dayjs().get("day") + 1, "d")
        .endOf("day"),
    ],
  },
  {
    label: DATE_TIME_PICKER.FILTER_LABLE.THIS_MONTH,
    value: [
      dayjs()
        .subtract(dayjs().get("date") - 1, "d")
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0),
      dayjs().endOf("day"),
    ],
  },
  {
    label: DATE_TIME_PICKER.FILTER_LABLE.LAST_MONTH,
    value: [
      dayjs()
        .subtract(1, "M")
        .set("date", 1)
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0),
      dayjs().subtract(dayjs().get("date"), "d").endOf("day"),
    ],
  },
];

export const getScreenType = () => {
  if (window.innerWidth >= 1600) {
    return "xxl";
  } else if (window.innerWidth >= 1200) {
    return "xl";
  } else if (window.innerWidth >= 992) {
    return "lg";
  } else if (window.innerWidth >= 768) {
    return "md";
  } else if (window.innerWidth >= 576) {
    return "sm";
  } else if (window.innerWidth >= 480) {
    return "xs";
  } else {
    return "xxs";
  }
};

export const dealerTheme = {
  lml: "#F3A6AC",
  nds: "#a67657",
  evdealer: "#a67657",
  "nds-dealer": "#a67657",
  nichesolv: "#ACB546",
};

export const formattedStringForDropdown = (str) => {
  return str
    ? str
        .toLowerCase()
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "";
};

export const getDomain = () => {
  const domainParts = window.location.hostname.split(".");
  const subdomain = domainParts.length >= 2 ? domainParts[0] : "";

  const environment = domains[process.env.REACT_APP_ENV];
  return environment ? environment[subdomain] || "" : "";
};

export const camelCaseToWords = (camelCaseString) => {
  return camelCaseString
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());
};

export const getGrafanaBaseURL = (dashboardId, dashboardName) => {
  return `${grafanaBaseUrl}/d-solo/${dashboardId}/${dashboardName}?`;
};

export const validatePhoneNumber = (rule, value, callback) => {
  const isValid = /^[+]?[0-9]*$/.test(value) && value.length === 13;

  if (!isValid) {
    callback("Invalid phone number. Must have 13 digits.");
  } else {
    callback();
  }
};

export const emailValidation = (value) => {
  var validRegex = /^[\w.+-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;

  return value.match(validRegex);
};

export const breadcrumbList = (lastValue) => {
  return [
    {
      title: DASHBOARD_MENU_LIST.includes(lastValue)
        ? BREADCRUMBS.DASHBOARDS
        : DISPLAYS_MENU_LIST.includes(lastValue)
        ? BREADCRUMBS.DISPLAYS
        : USER_MENU_LIST.includes(lastValue)
        ? BREADCRUMBS.USER
        : null,
    },
    {
      title: camelCaseToWords(lastValue),
    },
  ];
};
